import { Flex, Icon, Input } from '@chakra-ui/react';
import { RiSearchLine } from 'react-icons/ri';
import { search } from 'ss-search';

type ControlsData = {
  page: number;
  perPage: number;
  totalPage: number;
};
type FichaData = {
	banca: string;
	cliente: string;
	cod_emp: number;
	cod_ficha: number;
	cod_ped: string;
	cod_pro: number;
	cod_event: number;
	dat_cad: string;
	descricao: string;
	imagem: string;
	nome_pro: string;
	proxima_op: string;
	quant_atual: number;
	quant_incial: number;
	status_des: string;
	usuario: string;
	apontamento: boolean;
}
interface DataTableSearchParams {
  fichas: FichaData[];
  setPesqFichas: (clientes: FichaData[]) => void;
  controls: ControlsData;
  setControls: (control: ControlsData) => void;
  handleUpdateList: (
    page: number,
    perPage: number,
    fichass: FichaData[],
  ) => void;
}

const DataTableSearch: React.FC<DataTableSearchParams> = ({
  fichas,
  setPesqFichas,
  controls,
  setControls,
  handleUpdateList,
}) => {
  function handlePesquisa(event: string) {
    const texto = event;

    if (texto === '' || texto === ' ') {
      setPesqFichas(fichas);

      setControls({
        ...controls,
        page: 1,
        totalPage: Math.ceil(fichas.length / controls.perPage),
      });
      handleUpdateList(1, controls.perPage, fichas);
      return;
    }

		const searchKeys = [
			'cod_emp',
			'cod_ficha',
			'cod_pro',
			'usuario',
			'descricao',
			'dat_cad',
			'status_des',
			'cod_ped',
			'cliente',
			'nome_pro',
			'banca',
			'descricao',
			'quant_incial',
			'quant_atual',
			'proxima_op',
		];
    const results = search(fichas, searchKeys, texto) as FichaData[];

    setPesqFichas(results);
    setControls({
      ...controls,
      page: 1,
      totalPage: Math.ceil(results.length / controls.perPage),
    });

    handleUpdateList(1, controls.perPage, results);
  }

  return (
    <Flex
			as="form"
			ml={[0, 0, 0, 4]}
			mr={[4, 0]}
			w="100%"
		>
      <Flex
        as="label"
        flex="1"
        py="2"
        pl="2"
        pr="6"
        maxWidth={400}
        alignSelf="center"
        color="gray.900"
        position="relative"
        bg="gray.50"
        borderRadius="full"
      >
        <Input
          color="gray.900"
          variant="unstyled"
          px="4"
          mr="4"
          placeholder="Pesquisar"
          _placeholder={{ color: 'gray.400' }}
          onChange={e => handlePesquisa(e.target.value)}
        />

        <Icon as={RiSearchLine} fontSize="20" color="blue.500" />
      </Flex>
    </Flex>
  );
};

export default DataTableSearch;
